import React, { useEffect } from 'react'
import { Header } from '@/widgets/header'
import styles from './style.module.scss'
import { useToggle } from '@/shared'

export const ProfileTemplate = ({ title, children }) => {
	const [isOpen, toggleOpen] = useToggle()

	useEffect(() => {
		const root = document.querySelector('#root')
		if (isOpen) {
			root.style = 'overflow: hidden; height: 100vh;'
		} else {
			root.style = 'overflow: auto; height: 100%; scroll-behavior: smooth;'
		}
	}, [isOpen])

	return (
		<>
			<Header title={title} toggleOpen={toggleOpen} />
			<div className={styles.container}>{children}</div>
		</>
	)
}
